// Client copy of the middle-end allowlist in
// apps/middle-end/src/gql/types/Petition/mutations/ai/generateAiDraftFromSocialPost/platforms/allowlist/platforms.ts.
// Any source or domain change must be made in both.

type SocialPostPlatform = Readonly<{
	id: string;
	/** Apex domains, lowercase. Matches the apex or any subdomain; suffix look-alikes don't match. */
	domains: readonly string[];
}>;

export const SOCIAL_POST_PLATFORMS = [
	{ id: 'tiktok', domains: ['tiktok.com'] },
	{ id: 'instagram', domains: ['instagram.com'] },
	{ id: 'facebook', domains: ['facebook.com', 'fb.watch'] },
	{ id: 'reddit', domains: ['reddit.com', 'redd.it'] },
	{ id: 'x', domains: ['x.com', 'twitter.com'] },
	// Matching pasted links, not embedding: the nocookie host is only for iframes.
	// eslint-disable-next-line @change-corgi/youtube-embeds-nocookies
	{ id: 'youtube', domains: ['youtube.com', 'youtu.be'] },
	// Only Substack-hosted publications; custom domains won't match.
	{ id: 'substack', domains: ['substack.com'] },
	{ id: 'nytimes', domains: ['nytimes.com'] },
] as const satisfies readonly SocialPostPlatform[];

export type SocialPostPlatformId = (typeof SOCIAL_POST_PLATFORMS)[number]['id'];
